require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./postes-de-professeurs-0-5-1.json") })
        }
      }, "path---postes-de-professeurs-0-5-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---postes-de-professeurs-0-5-1!./.cache/json/postes-de-professeurs-0-5-1.json
// module id = 529
// module chunks = 231608221292675